import { EmailIconDefault } from '@/components/atoms/icons/EmailIconDefault'
import { PhoneIconDefault } from '@/components/atoms/icons/PhoneIconDefault'

export enum ContactServiceOption {
  Email = 0,
  Phone = 1
}
export type ContactService = {
  id: number
  title: string
  text: string
  IconElement: JSX.Element
  time?: string
  type: string
}

export const contactServiceData: ContactService[] = [
  {
    id: 0,
    title: 'Contact.emailContactUs',
    text: 'Contact.showEmail',
    IconElement: <EmailIconDefault width={40} height={50} />,
    type: 'email'
  },
  {
    id: 1,
    title: 'Contact.phoneContactUs',
    text: 'Contact.showPhone',
    IconElement: <PhoneIconDefault height={50} width={40} />,
    time: 'Po-Pia 9:00-16:00',
    type: 'phone'
  }
]
